module.exports = __webpack_public_path__ + "static/media/Kidney-shape.6f1ef8df.svg";